import ReduxUndo from "redux-undo";
import * as editorActionsTypes from "state/ui/editor/editorActionTypes";

export const initState = {
  designData: null,
  editorState: null
};

// Note: designData is intentionally NOT reset on ROUTE_CHANGED. Under the data
// router the redux route-change dispatch and the React route unmount are
// decoupled, so clearing designData here runs mapStateToProps for the ~55 still
// -mounted editor containers (many of which read designData.id) before they
// unmount, crashing the app on navigation out of the editor. Instead the design
// payload and undo history are freed via RESET_EDITOR_HISTORY, dispatched from
// EditorContainer's deferred unmount cleanup once the editor has left the screen.
const editorReducers = (state = initState, action) => {
  switch (action.type) {
    case editorActionsTypes.LOAD_DESIGN:
    case editorActionsTypes.SAVE_DESIGN: {
      return {
        ...state,
        designData: action.data,
        editorState: action.editorState
      };
    }

    default:
      return state;
  }
};

// Every SAVE_DESIGN pushes a full deep clone of designData onto the history (Editor
// cloneDeeps state before saving), so an unbounded history retains one ~1MB copy per
// save. redux-undo defaults `limit` to undefined, which never truncates: a long session
// on a large design accumulated 700+ clones and starved the tab. Bound it — 50 steps is
// well past what undo is used for in practice.
const ReduxUndoOptions = {
  initTypes: editorActionsTypes.RESET_EDITOR_HISTORY,
  limit: 50
};

export default ReduxUndo(editorReducers, ReduxUndoOptions);
